exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "app-root {\n    margin: 35px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/Sadri/Workspace/Minesweeper/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/Sadri/Workspace/Minesweeper/node_modules/postcss-loader?{"ident":"postcss"}!/Users/Sadri/Workspace/Minesweeper/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles